import {
    ValidateEmailFunction,
    ValidateFormFunction,
    ValidatePasswordFunction,
} from "./types"
import { PASSWORD_CONSTRAINTS } from "../../../../constants/progressBanner"

export const validateEmail: ValidateEmailFunction = async (email, touched) => {
    if (!email && touched) {
        return "入力してください"
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    if (email && !emailRegex.test(email)) {
        return "有効なメールアドレスを入力してください"
    }

    if (email) {
        try {
            const response = await fetch("/api/v1/users/check_if_registered", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user: { email: email },
                }),
            })

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`)
            }

            const data = await response.json()
            if (!data) {
                return "このメールアドレスはすでに登録されています"
            }
        } catch (error) {
            return "サーバーとの通信に失敗しました"
        }
    }
}

export const validatePassword: ValidatePasswordFunction = (
    password,
    touched
) => {
    if (!password && touched) {
        return "入力してください"
    }
    if (password) {
        if (
            password.length < PASSWORD_CONSTRAINTS.MIN_LENGTH ||
            password.length > PASSWORD_CONSTRAINTS.MAX_LENGTH
        ) {
            return "パスワードは8文字以上32文字以下で入力してください"
        }
        if (!/[A-Z]/.test(password)) {
            return "大文字を含めてください"
        }
        if (!/[a-z]/.test(password)) {
            return "小文字を含めてください"
        }
        if (!/[0-9]/.test(password)) {
            return "数字を含めてください"
        }
    }
}

export const validateForm: ValidateFormFunction = async (
    email,
    password,
    touched
) => {
    const emailError = await validateEmail(email, touched.email)
    const passwordError = validatePassword(password, touched.password)

    return {
        errors: {
            email: emailError,
            password: passwordError,
        },
        isValid:
            email !== "" && password !== "" && !emailError && !passwordError,
    }
}
